import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IssueActionProgressEnum } from '@issuemanager/constants';

type Props = {
  value: IssueActionProgressEnum;
};

export function IssueActionProgressLabel({ value }: Props) {
  const issueActionProgress = useIssueActionProgress();
  const issueStatus = issueActionProgress.find((s) => s.value === value);

  return issueStatus?.label ?? null;
}

export interface IssueActionProgressData {
  id: string;
  value: IssueActionProgressEnum;
  label: string;
}
export const useIssueActionProgress = () => {
  const { t } = useTranslation('issue');

  const issueActionProgress: IssueActionProgressData[] = useMemo(
    () => [
      {
        id: '1',
        value: IssueActionProgressEnum.BLANK,
        label: t('view.actionProgress.blank'),
      },
      {
        id: '2',
        value: IssueActionProgressEnum.NOT_INITIATED,
        label: t('view.actionProgress.notInitiated'),
      },
      {
        id: '3',
        value: IssueActionProgressEnum.INITIATED,
        label: t('view.actionProgress.initiated'),
      },
      {
        id: '4',
        value: IssueActionProgressEnum.ONGOING,
        label: t('view.actionProgress.ongoing'),
      },
      {
        id: '5',
        value: IssueActionProgressEnum.COMPLETED,
        label: t('view.actionProgress.completed'),
      },
      {
        id: '6',
        value: IssueActionProgressEnum.DISCARDED,
        label: t('view.actionProgress.discarded'),
      },
    ],
    [],
  );

  return issueActionProgress;
};
